import { type PropsWithChildren } from 'react'

import { AppRenderingErrorFallbackPage } from '~pages/errors/appLevel'

import { AppAppErrorBoundary } from '~widgets/renderErrorBoundary/global'

export const AppRenderingErrorBoundary = ({ children }: PropsWithChildren) => (
	<AppAppErrorBoundary fallback={<AppRenderingErrorFallbackPage />}>{children}</AppAppErrorBoundary>
)
